import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocumentCurrentStatus } from '../../requests/getDocumentCurrentStatus';

export const useDocumentCurrentStatus = (
  documentId: string,
  definitionName: string,
  statusDefinitionName: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentCurrentStatus>>
  >({
    queryKey: [DOCUMENTS_BASE_PATH, documentId, 'status', statusDefinitionName],
    queryFn: () =>
      getDocumentCurrentStatus(
        constructGet,
        documentId,
        definitionName,
        statusDefinitionName,
      ),
    enabled:
      Boolean(documentId) &&
      Boolean(statusDefinitionName) &&
      (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'currentStatus'),
    ...rest,
  };
};
